import {Observable} from 'rxjs';
import {StudyOverviewPageData, TitlePageData} from '../../../../pages/reporting-tool/model/common-page-data';

export abstract class ReportRenderService {
    abstract getTitlePageContent(reportCode: string): Observable<TitlePageData>;

    abstract getStudyOverviewPageContent(reportCode: string, workflowItemId: number): Observable<StudyOverviewPageData>;
}
